module.exports = __webpack_public_path__ + "static/jigyo3-5974b6663b7610578d41697c87749272.jpg";